import { useState } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Submission } from "@/models/database/submissions/Submission.model";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { timestamp } from "@/api/firebase/firebase.config";
import { useSubmissionsStore } from "@/store/submissions/submissions.store";

export const useUpdateStatus = (id: string) => {
  const user = useCurrentUserProfile((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const { updateSubmission } = useSubmissionsStore();

  const updateStatus = async (
    submission: Submission,
    status: "approved" | "rejected" | "pending"
  ) => {
    if (!user) {
      setError(new Error("User not authenticated"));
      return;
    }

    setLoading(true);
    try {
      await collectionRef
        .submissions(brand.tenantId)
        .doc(id)
        .update({
          ...submission,
          status: status,
        })
        .then(() => {
          updateSubmission({
            ...submission,
            status: status,
          });
        });

      const timestampToMS = new Date().getTime();
      const fieldToCompare = submission.fieldToCompare;

      if (status === "approved") {
        await collectionRef
          .match_results(brand.tenantId)
          .doc(`${submission.uid}_${submission.gameId}_${timestampToMS}`)
          .set({
            client: brand.tenantId,
            created: timestamp.now(),
            docId: `${submission.uid}_${submission.gameId}_${timestampToMS}`,
            game: submission.gameId,
            gameType: submission.gameId,
            [fieldToCompare]: submission.points,
            pending: false,
            uid: submission.uid,
          });
      }

      if (status === "rejected") {
        await collectionRef
          .match_results(brand.tenantId)
          .where(`${[fieldToCompare]}`, "==", submission.points)
          .where("uid", "==", submission.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists) {
                doc.ref.delete();
              }
            });
          });
      }

      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return { updateStatus, loading, error };
};
